module.exports = __webpack_public_path__ + "img/n4.ef50c34f.png";